import { render, staticRenderFns } from "./InvoiceHeader.vue?vue&type=template&id=56876b71&"
import script from "./InvoiceHeader.vue?vue&type=script&lang=ts&"
export * from "./InvoiceHeader.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceHeader.vue?vue&type=style&index=0&id=56876b71&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports